/**
 * Single switch for every supplement feature: the per-section Supplements tab,
 * the consolidated Supplements panel (screen + PDF), its "Include in PDF"
 * setting, the Supplement Settings brand toggles (incl. the BWH Labs second
 * brand), and the Holobiome Roadmap panel. They ship together, so they read one
 * flag rather than each repeating an env check that can drift.
 *
 * Currently: visible everywhere EXCEPT prod.
 *
 * Fails closed. Only scripts/deploy.js sets REACT_APP_ENV, so a plain
 * `npm run build` leaves it unset — that must read as "hidden" rather than
 * "not prod", which is what a bare `!== 'prod'` would wrongly do. `npm start`
 * (NODE_ENV=development) and jest are always visible unless REACT_APP_ENV
 * explicitly names prod, which is what lets tests exercise the prod path.
 *
 * A function, not a const, so it re-reads the env per call; CRA still inlines
 * both process.env reads at build time.
 */
export function supplementsVisible(): boolean {
  if (process.env.REACT_APP_ENV === 'prod') return false;
  if (process.env.NODE_ENV !== 'production') return true;
  return !!process.env.REACT_APP_ENV;
}
